<basic-label></basic-label>
<div class="form__inline-field-container form__inline-field-container--two-fields form--full-width">
  <div class="form__field">
    <select-basic
      [property]="getCustomProp(0)"
      [showTitle]="false"
      [label]="getPlaceholder(0) || 'Plan'"
      [placeholder]="'Select'"
    ></select-basic>
  </div>
  <div class="form__field">
    <basic-text-input
      [propertyName]="getCustomProp(1)"
      [label]="'Face Amount'"
      [placeholder]="'$'"
      [alwaysShowPlaceholder]="true"
      parserType="CurrencyRoundedToDollar"
    ></basic-text-input>
  </div>
</div>
